import { Class } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    timeTable: [],
    configData: [],
  },
  actions: {
    async updateLesson(_, data) {
      const res = await Class.updateLesson(data)
      return res
    },
    setTimeTable({ commit }, data) {
      commit('setTimeTable', data)
    },
    setConfigData({ commit }, data) {
      commit('setConfigData', data)
    },
    reset({ commit }) {
      commit('resetData')
    },
  },
  mutations: {
    setTimeTable(state, data) {
      if (Array.isArray(data)) {
        state.timeTable = data.map((v, i) => ({ ...v, index: i + 1 }))
      }
    },
    setConfigData(state, data) {
      state.configData = data
    },
    resetData(state) {
      state.timeTable = []
      state.configData = []
    },
  },
}
